import http from "../../http";

/**
 * 微信消息相关接口
 */
export default {
  // 发送消息
  send: (appid, params) => {
    return http.post("marketcenter/wxproxy/" + appid + "/sendmsg", params);
  },
  // 消息模板列表
  templateList: (appid) => {
    return http.get("marketcenter/wxproxy/" + appid + "/template/list");
  },
};
